import { Backdrop, CircularProgress, withStyles } from '@material-ui/core';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { ClosableDialog, HeaderTitle } from '@/components';
import { useSubmitting } from '@/hooks';
import { AnyTransactionPeriod } from '@/model/wallets/types';
import { noop } from '@/utils/functions';
import { Func } from '@/utils/ts';

import TransactionFilterOptionsSelection from '../TransactionFilterOptionsSelection';

interface TransactionFilterDialogProps {
  'data-test'?: string;
  value: AnyTransactionPeriod;
  onSelect: Func<[AnyTransactionPeriod]>;
  onClose?: Func;
}

const LimitedBackdrop = withStyles({
  root: {
    position: 'absolute',
    zIndex: 1,
  },
})(Backdrop);

const TransactionFilterDialog: React.FC<TransactionFilterDialogProps> = ({
  onSelect,
  onClose = noop(),
  value,
  'data-test': dataTest,
}) => {
  const [submitting, withSubmitting] = useSubmitting(false);
  const selectOption = useMemo(() => withSubmitting(onSelect), [onSelect, withSubmitting]);

  return (
    <ClosableDialog
      onClose={onClose}
      visible
      data-test={dataTest && `${dataTest}-container`}
      title={<HeaderTitle title={<FormattedMessage id="demo.pages.transactions.filter.select.title" />} />}
    >
      {submitting && (
        <LimitedBackdrop open>
          <CircularProgress color="inherit" />
        </LimitedBackdrop>
      )}
      <TransactionFilterOptionsSelection
        onSelect={selectOption}
        value={value}
        data-test={dataTest && `${dataTest}-selection`}
      />
    </ClosableDialog>
  );
};

export default React.memo(TransactionFilterDialog);
